var _rect, _path, _g, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 111,
    viewBox: "0 0 156 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 110,
    transform: "translate(0 0.562378)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7171_35375)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7171_35375)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7171_35375",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -31,
    y: 22,
    width: 126,
    height: 66
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.0909 22.3828H-29.0909C-30.1453 22.3828 -31 23.2435 -31 24.3051V85.8197C-31 86.8814 -30.1453 87.742 -29.0909 87.742H93.0909C94.1453 87.742 95 86.8814 95 85.8197V24.3051C95 23.2435 94.1453 22.3828 93.0909 22.3828Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7171_35375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0909 22.3828H-29.0909C-30.1453 22.3828 -31 23.2435 -31 24.3051V85.8197C-31 86.8814 -30.1453 87.742 -29.0909 87.742H93.0909C94.1453 87.742 95 86.8814 95 85.8197V24.3051C95 23.2435 94.1453 22.3828 93.0909 22.3828Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.2394 64.2245C78.373 64.2894 96.9637 76.7816 103.068 78.2131C109.172 79.6445 107.23 87.9073 107.23 87.9073H8.86597C8.86597 87.9073 43.4112 68.844 47.4349 69.82C51.458 70.796 50.9031 73.008 54.3713 73.0731C57.8401 73.1382 68.1065 64.1595 73.2394 64.2245Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.1807 55.2502C-15.4774 55.3399 -27.4167 72.5656 -31.3371 74.5395C-35.2575 76.5134 -34.0101 87.9073 -34.0101 87.9073H29.1613C29.1613 87.9073 6.97558 61.6203 4.39169 62.9661C1.8078 64.3118 2.16436 67.3621 -0.0631714 67.4518C-2.29076 67.5416 -8.88406 55.1607 -12.1807 55.2502Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6407 70.5996C71.3437 70.6471 59.4043 79.7766 55.4843 80.8226C51.5636 81.8688 52.8109 87.9073 52.8109 87.9073H115.983C115.983 87.9073 93.7965 73.9756 91.2129 74.6889C88.6293 75.4021 88.9856 77.0187 86.7584 77.0663C84.5304 77.1139 77.9371 70.5521 74.6407 70.5996Z",
    fill: "#D9D9D9"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 87,
    y: 45.0746,
    width: 34.202,
    height: 7.2085,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 87,
    y: 55.829,
    width: 38.0641,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 87,
    y: 60.0472,
    width: 42.9645,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 87,
    y: 64.2655,
    width: 26.8707,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7171_35375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(11 23.0624)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7171_35375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 66,
    fill: "white",
    transform: "translate(-31 22.0624)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLeft);
export default __webpack_public_path__ + "static/media/image-left.e5993b45572bc559ba889726925b3d48.svg";
export { ForwardRef as ReactComponent };